import { configureStore } from "@reduxjs/toolkit"
import authReducer from "./authSlice"
import userReducer from "./userSlice"
import clientsReducer from "./clientsSlice"
import eventsReducer from "./eventsSlice"
import holidaysReducer from "./holidaysSlice"
import targetAudienceReducer from "./targetAudienceSlice"
import facebookPagesReducer from "./facebookPagesSlice"
import facebookPlacesReducer from "./facebookPlacesSlice"
import toneOfVoiceReducer from "./toneOfVoiceSlice"
import socialNetworkTypesReducer from "./socialNetworkTypesSlice"
import mediaUploadReducer from "./mediaUploadSlice"
import contentPillarsReducer from "./contentPillarsSlice"
import campaignReducer from "./campaignSlice"
import topicsReducer from "./topicsSlice"
import approvalReducer from "./approvalSlice"
import collaboratorsReducer from "./collaboratorsSlice"
import notifyEmailReducer from "./notifyEmailSlice"
import approverReducer from "./approverSlice"
import commentsReducer from "./commentsSlice"
import postEditHistoryReducer from "./postEditHistorySlice"
import postStatusReducer from "./postStatusSlice"
import generatePostReducer from "./generatePostSlice"
import mediaReplaceReducer from "./mediaReplaceSlice"
import rewritePostReducer from "./rewritePostSlice"
import checkMyCopyReducer from "./checkMyCopySlice"
import deleteTopicReducer from "./deleteTopicSlice"
import deletePostsBulkReducer from "./deletePostsBulkSlice"
import mediaTagsReducer from "./mediaTagsSlice"
import socialNetworkAccountsReducer from "./socialNetworkAccountsSlice"
import sendOtpReducer from "./sendOtpSlice"
import verifyOtpReducer from "./verifyOtpSlice"
import registerPasswordReducer from "./registerPasswordSlice"
import hotelsReducer from "./hotelsSlice"
import entitySearchReducer from "./entitySearchSlice"
import clientCompsetReducer from "./clientCompsetSlice"
import countriesReducer from "./countriesSlice"
import statesReducer from "./statesSlice"
import citiesReducer from "./citiesSlice"
import worldGeographyReducer from "./worldGeographySlice"
import timezonesReducer from "./timezonesSlice"
import createClientReducer from "./createClientSlice"
import onboardingReducer from "./onboardingSlice"
import organizationReducer from "./organizationSlice"
import mediaStatsReducer from "./mediaStatsSlice"
import organizationsReducer from "./settingOrganizationSlice"
import mediaDeleteReducer from "./mediaDeleteSlice"
import postMediaDeleteReducer from "./postMediaDeleteSlice"
import mediaDownloadReducer from "./mediaDownloadSlice"
import publisherReducer from "./publisherSlice"
import viewAccountReducer from "./viewAccountSlice"
import invitedUserReducer from "./invitedUserSlice"
import organizationRoleReducer from "./organizationRoleSlice"
import resetPasswordReducer from "./resetPasswordSlice"
import citiesAiReducer from "./citiesAiSlice"
import messageTypesReducer from "./messageTypesSlice"
import messagesReducer from "./messagesSlice"
import liveEngagementReducer from "./liveEngagementSlice"
import interactionMessagesReducer from "./interactionMessagesSlice"
import messageSuggestionsReducer from "./messageSuggestionsSlice"
import replyMessageReducer from "./replyMessageSlice"
import messageHideReducer from "./messageHideSlice"
import messageLikeReducer from "./messageLikeSlice"
import alertPeopleReducer from "./alertPeopleSlice"
import alertGroupsReducer from "./alertGroupsSlice"
import alertUserCreateReducer from "./alertUserCreateSlice"
import alertGroupCreateReducer from "./alertGroupCreateSlice"
import alertUserUpdateReducer from "./alertUserUpdateSlice"
import alertGroupUpdateReducer from "./alertGroupUpdateSlice"
import alertUserDeleteReducer from "./alertUserDeleteSlice"
import alertGroupDeleteReducer from "./alertGroupDeleteSlice"
import messageArchiveReducer from "./messageArchiveSlice"
import alertReducer from "./alertSlice"
import monitoringScheduleReducer from "./monitoringScheduleSlice"
import messageTagReducer from "./messageTagSlice"
import guestNotesReducer from "./guestNotesSlice"
import mediaReuseStatsReducer from "./mediaReuseStatsSlice"
import auditReducer from "./auditSlice"
import mediaAnalysisStatusReducer from "./mediaAnalysisStatusSlice"
import instagramValidateReducer from "./instagramValidateSlice"
import entitySocialNetworkValidateReducer from "./entitySocialNetworkValidateSlice"
import entityCreateReducer from "./entityCreateSlice"
import entitySocialNetworkAccountsReducer from "./entitySocialNetworkAccountsSlice"
import liveSocialPostDeleteReducer from "./liveSocialPostDeleteSlice"
import assetUploadReducer from "./assetUploadSlice"
import userSessionsReducer from "./userSessionsSlice"
import cacheRefreshReducer from "./cacheRefreshSlice"
import cadenceReducer from "./cadenceSlice"
import alertTypesReducer from "./alertTypesSlice"
import alertClientCategoriesReducer from "./alertClientCategoriesSlice"
import emailApprovalReducer from "./emailApprovalslice"
import inboxThreadsReducer from "./inboxThreadsSlice"
import clientNoteTypesReducer from "./clientNoteTypesSlice"
import clientNotesReducer from "./clientNotesSlice"
import clientAdAccountReducer from "./clientAdAccountSlice"
import moderatorsReducer from "./moderatorsSlice"
import inboxSummaryReducer from "./inboxSummarySlice"
import inboxHealthReducer from "./inboxHealthSlice"
import dailyPerformanceReducer from "./dailyPerformanceSlice"
import dailyPostStatsReducer from "./dailyPostStatsSlice"
import clientMessagesReportReducer from "./clientMessagesReportSlice"
import clientSentimentsReportReducer from "./clientSentimentsReportSlice"
import clientAlertsReportReducer from "./clientAlertsReportSlice"
import clientMessagesTimeOfDayReducer from "./clientMessagesTimeOfDaySlice"
import clientAlertsTimeOfDayReducer from "./clientAlertsTimeOfDaySlice"
import clientMessagesHeatmapReducer from "./clientMessagesHeatmapSlice"
import clientDemographicsFollowersReducer from "./clientDemographicsFollowersSlice"
import clientPostHeatmapReducer from "./clientPostHeatmapSlice"
import clientTopPostsReducer from "./clientTopPostsSlice"
import clientSocialPerformanceReducer from "./clientSocialPerformanceSlice"
import clientCompetitivePerformanceReducer from "./clientCompetitivePerformanceSlice"
import clientCampaignPerformanceReducer from "./clientCampaignPerformanceSlice"
import clientStoryPerformanceReducer from "./clientStoryPerformanceSlice"
import clientPaidPerformanceReducer from "./clientPaidPerformanceSlice"
import organizationPaidReportReducer from "./organizationPaidReportSlice"
import organizationPageReportReducer from "./organizationPageReportSlice"
import organizationPaidTopCampaignsReducer from "./organizationPaidTopCampaignsSlice"
import organizationSentimentScoreReducer from "./organizationSentimentScoreSlice"
import organizationConversationTopicsReducer from "./organizationConversationTopicsSlice"
import organizationConversationTopicDetailsReducer from "./organizationConversationTopicDetailsSlice"
import organizationPageEngagementRateReducer from "./organizationPageEngagementRateSlice"
import organizationPagePropertyOutliersReducer from "./organizationPagePropertyOutliersSlice"
import organizationBrandsReducer from "./organizationBrandsSlice"
import organizationInboxHealthReducer from "./organizationInboxHealthSlice"
import clientPaidMediaPerformanceReducer from "./clientPaidMediaPerformanceSlice"
import clientChartPerformanceReducer from "./clientChartPerformanceSlice"
import metricGoalTypesReducer from "./metricGoalTypesSlice"
import metricGoalsReducer from "./metricGoalsSlice"
import clientMetricGoalsReducer from "./clientMetricGoalsSlice"
import clientYtdPagePerformanceReducer from "./clientYtdPagePerformanceSlice"
import inboxStreamReducer from "./inboxStreamSlice"
import aiPlannerReducer from "./aiPlannerSlice"
import aiPlannerApiReducer from "./aiPlannerApiSlice"
import aiPlannerPreferencesReducer from "./aiPlannerPreferencesSlice"
import postsRegenerateReducer from "./postsRegenerateSlice"
import exemplarPostReducer from "./exemplarPostSlice"
import customContentPillarReducer from "./customContentPillarSlice"
import propertyDetailReducer from "./propertyDetailSlice"
import clientMarketingSettingsReducer from "./clientMarketingSettingsSlice"
import clientDetailsReducer from "./clientDetailsSlice"
import inboxClientsReducer from "./inboxClientsSlice"
import outOfOfficeReducer from "./outOfOfficeSlice"
import monitorGroupsReducer from "./monitorGroupSlice"
import successToastReducer from "./successToastSlice"
import mediaLibraryReducer from "./mediaLibrarySlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    clients: clientsReducer,
    events: eventsReducer,
    holidays: holidaysReducer,
    targetAudience: targetAudienceReducer,
    facebookPages: facebookPagesReducer,
    facebookPlaces: facebookPlacesReducer,
    toneOfVoice: toneOfVoiceReducer,
    socialNetworkTypes: socialNetworkTypesReducer,
    mediaUpload: mediaUploadReducer,
    contentPillars: contentPillarsReducer,
    campaign: campaignReducer,
    topics: topicsReducer,
    approval: approvalReducer,
    collaborators: collaboratorsReducer,
    notifyEmail: notifyEmailReducer,
    approver: approverReducer,
    comments: commentsReducer,
    postEditHistory: postEditHistoryReducer,
    postStatus: postStatusReducer,
    generatePost: generatePostReducer,
    mediaReplace: mediaReplaceReducer,
    rewritePost: rewritePostReducer,
    checkMyCopy: checkMyCopyReducer,
    deleteTopic: deleteTopicReducer,
    deletePostsBulk: deletePostsBulkReducer,
    mediaTags: mediaTagsReducer,
    socialNetworkAccounts: socialNetworkAccountsReducer,
    sendOtp: sendOtpReducer,
    verifyOtp: verifyOtpReducer,
    registerPassword: registerPasswordReducer,
    hotels: hotelsReducer,
    entitySearch: entitySearchReducer,
    clientCompset: clientCompsetReducer,
    countries: countriesReducer,
    states: statesReducer,
    cities: citiesReducer,
    worldGeography: worldGeographyReducer,
    timezones: timezonesReducer,
    createClient: createClientReducer,
    onboarding: onboardingReducer,
    organization: organizationReducer,
    mediaStats: mediaStatsReducer,
    organizations: organizationsReducer,
    mediaDelete: mediaDeleteReducer,
    postMediaDelete: postMediaDeleteReducer,
    mediaDownload: mediaDownloadReducer,
    publisher: publisherReducer,
    viewAccount: viewAccountReducer,
    invitedUser: invitedUserReducer,
    organizationRole: organizationRoleReducer,
    resetPassword: resetPasswordReducer,
    citiesAi: citiesAiReducer,
    messageTypes: messageTypesReducer,
    messages: messagesReducer,
    liveEngagement: liveEngagementReducer,
    interactionMessages: interactionMessagesReducer,
    messageSuggestions: messageSuggestionsReducer,
    replyMessage: replyMessageReducer,
    messageHide: messageHideReducer,
    messageLike: messageLikeReducer,
    alertPeople: alertPeopleReducer,
    alertGroups: alertGroupsReducer,
    alertUserCreate: alertUserCreateReducer,
    alertGroupCreate: alertGroupCreateReducer,
    alertUserUpdate: alertUserUpdateReducer,
    alertGroupUpdate: alertGroupUpdateReducer,
    alertUserDelete: alertUserDeleteReducer,
    alertGroupDelete: alertGroupDeleteReducer,
    messageArchive: messageArchiveReducer,
    alert: alertReducer,
    monitoringSchedule: monitoringScheduleReducer,
    messageTags: messageTagReducer,
    guestNotes: guestNotesReducer,
    mediaReuseStats: mediaReuseStatsReducer,
    audit: auditReducer,
    mediaAnalysisStatus: mediaAnalysisStatusReducer,
    instagramValidate: instagramValidateReducer,
    entitySocialNetworkValidate: entitySocialNetworkValidateReducer,
    entityCreate: entityCreateReducer,
    entitySocialNetworkAccounts: entitySocialNetworkAccountsReducer,
    liveSocialPostDelete: liveSocialPostDeleteReducer,
    assetUpload: assetUploadReducer,
    userSessions: userSessionsReducer,
    cacheRefresh: cacheRefreshReducer,
    cadence: cadenceReducer,
    alertTypes: alertTypesReducer,
    alertClientCategories: alertClientCategoriesReducer,
    emailApproval: emailApprovalReducer,
    inboxThreads: inboxThreadsReducer,
    clientNoteTypes: clientNoteTypesReducer,
    clientNotes: clientNotesReducer,
    clientAdAccount: clientAdAccountReducer,
    moderators: moderatorsReducer,
    inboxSummary: inboxSummaryReducer,
    inboxHealth: inboxHealthReducer,
    dailyPerformance: dailyPerformanceReducer,
    dailyPostStats: dailyPostStatsReducer,
    clientMessagesReport: clientMessagesReportReducer,
    clientSentimentsReport: clientSentimentsReportReducer,
    clientAlertsReport: clientAlertsReportReducer,
    clientMessagesTimeOfDay: clientMessagesTimeOfDayReducer,
    clientAlertsTimeOfDay: clientAlertsTimeOfDayReducer,
    clientMessagesHeatmap: clientMessagesHeatmapReducer,
    clientDemographicsFollowers: clientDemographicsFollowersReducer,
    clientPostHeatmap: clientPostHeatmapReducer,
    clientTopPosts: clientTopPostsReducer,
    clientSocialPerformance: clientSocialPerformanceReducer,
    clientCompetitivePerformance: clientCompetitivePerformanceReducer,
    clientCampaignPerformance: clientCampaignPerformanceReducer,
    clientStoryPerformance: clientStoryPerformanceReducer,
    clientPaidPerformance: clientPaidPerformanceReducer,
    organizationPaidReport: organizationPaidReportReducer,
    organizationPageReport: organizationPageReportReducer,
    organizationPaidTopCampaigns: organizationPaidTopCampaignsReducer,
    organizationSentimentScore: organizationSentimentScoreReducer,
    organizationConversationTopics: organizationConversationTopicsReducer,
    organizationConversationTopicDetails: organizationConversationTopicDetailsReducer,
    organizationPageEngagementRate: organizationPageEngagementRateReducer,
    organizationPagePropertyOutliers: organizationPagePropertyOutliersReducer,
    organizationBrands: organizationBrandsReducer,
    organizationInboxHealth: organizationInboxHealthReducer,
    clientPaidMediaPerformance: clientPaidMediaPerformanceReducer,
    clientChartPerformance: clientChartPerformanceReducer,
    metricGoalTypes: metricGoalTypesReducer,
    metricGoals: metricGoalsReducer,
    clientMetricGoals: clientMetricGoalsReducer,
    clientYtdPagePerformance: clientYtdPagePerformanceReducer,
    inboxStream: inboxStreamReducer,
    aiPlanner: aiPlannerReducer,
    aiPlannerApi: aiPlannerApiReducer,
    aiPlannerPreferences: aiPlannerPreferencesReducer,
    postsRegenerate: postsRegenerateReducer,
    exemplarPosts: exemplarPostReducer,
    customContentPillar: customContentPillarReducer,
    propertyDetail: propertyDetailReducer,
    clientMarketingSettings: clientMarketingSettingsReducer,
    clientDetails: clientDetailsReducer,
    inboxClients: inboxClientsReducer,
    outOfOffice: outOfOfficeReducer,
    monitorGroups: monitorGroupsReducer,
    successToast: successToastReducer,
    mediaLibrary: mediaLibraryReducer,
  },
})
